import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { LoginService } from 'src/app/services/login/login.service';
import { CookieService } from 'angular2-cookie';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  userInfo = [];
  locationParam;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private cookie: CookieService
  ) {}

  ngOnInit(): void {
    this.locationParam = window.location.href;
    console.log('location :>> ', location);
  }

  login = (): any => {
    this.loginService
      .validate(this.username, this.password, this.locationParam)
      .subscribe(
        (res) => {
          // this.loginService.setUserInfo({ user: res['user'] });
          // if (res !== null) {
          //   this.userInfo = [res];

          //   localStorage.setItem('username', this.username);

          //   localStorage.setItem('userId', this.userInfo[0].userId);
          //   const userIdLS = localStorage.getItem('userId');

          //   localStorage.setItem('userRoleId', this.userInfo[0].userRoleId);
          //   const userRoleIdLS = localStorage.getItem('userRoleId');

          //   // localStorage.setItem('userToken', this.userInfo[0].token);
          //   localStorage.setItem('userToken', 'true');

          //   const d = new Date();
          //   const year = d.getFullYear();
          //   const month = d.getMonth();
          //   const day = d.getDate();
          //   const c = new Date(year + 1, month, day);
          //   const opts = {
          //     expires: c,
          //   };

          //   this.cookie.put('Bearer_auth', this.userInfo[0].token, opts);

          //   console.log(
          //     'localStorage.getItem("userToken") :>> ',
          //     localStorage.getItem('userToken')
          //   );

          //   switch (userRoleIdLS) {
          //     case '1':
          //       this.router.navigate(['/empresas']);
          //       break;
          //   }
          // }
          console.log('res :>> ', res.message);
          if (res.message === 'Sin servicio') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Sin servicio',
              returnInputValueOnDeny: false,
            });
          } else if (res.message === 'No se pudo encontrar el usuario.') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text:
                'Nombre de usuario o contraseña incorrectos, intenta nuevamente.',

              returnInputValueOnDeny: false,
            });
          } else {
            this.userInfo = [res];

            localStorage.setItem('username', this.username);

            localStorage.setItem('userId', this.userInfo[0].userId);
            const userIdLS = localStorage.getItem('userId');

            localStorage.setItem('userRoleId', this.userInfo[0].userRoleId);
            const userRoleIdLS = localStorage.getItem('userRoleId');

            // localStorage.setItem('userToken', this.userInfo[0].token);
            localStorage.setItem('userToken', 'true');

            const d = new Date();
            const year = d.getFullYear();
            const month = d.getMonth();
            const day = d.getDate();
            const c = new Date(year + 1, month, day);
            const opts = {
              expires: c,
            };

            this.cookie.put('Bearer_auth', this.userInfo[0].token, opts);

            console.log(
              'localStorage.getItem("userToken") :>> ',
              localStorage.getItem('userToken')
            );

            switch (userRoleIdLS) {
              case '1':
                this.router.navigate(['/empresas']);
                break;
            }
          }
        }
        // (err) => {
        //   if (err.message === 'No se pudo encontrar el usuario.') {
        //     Swal.fire({
        //       icon: 'error',
        //       title: 'Oops...',
        //       text:
        //         'Nombre de usuario o contraseña incorrectos, intenta nuevamente.',
        //     });
        //   }
        // }
      );
  };
}
